/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { ICoreContext, IGeneric, IAny } from '@msdyn365-commerce/core';
import { IAccountWelcomeTileViewProps } from '@msdyn365-commerce-modules/account-management/src/modules/account-welcome-tile/./account-welcome-tile';
import { IAccountWelcomeTileData } from './account-welcome-tile.data';
import { currencyFormat } from '../../../utils/helper';
import { IAccountWelcomeTileProps } from '../definition-extensions/account-welcome-tile.ext.props.autogenerated';

const AccountWelcomeTileView: React.FC<IAccountWelcomeTileViewProps & IAccountWelcomeTileProps<IAccountWelcomeTileData>> = props => {
    const { customerAccountNumber, companyCreditLimit, myAccount } = props.resources;
    const _getBalance = (
        accountNumber?: string,
        creditLimit?: number,
        context?: ICoreContext<IGeneric<IAny>>,
        isPrepaidCustomer?: boolean
    ): React.ReactNode => {
        return (
            <div className='account-credit-balance__view customer-info'>
                <div className='account-credit-balance__view'>
                    <span>{customerAccountNumber}</span>
                    <span>{accountNumber}</span>
                </div>
                {!isPrepaidCustomer &&
                props?.context?.actionContext?.requestContext?.apiSettings?.oun !== props.context.app.config.ounNumberForUsSite ? (
                    <div className='account-credit-balance__view'>
                        <span>
                            {companyCreditLimit}{' '}
                            {props?.context?.actionContext?.requestContext?.apiSettings?.oun !==
                                props.context.app.config.ounNumberForUsSite}
                        </span>
                        <span>{currencyFormat(creditLimit, context)}</span>
                    </div>
                ) : null}
            </div>
        );
    };
    const {
        AccountWelcomeTile,
        data: { accountInformation, balance },
        context
    } = props;

    const result = accountInformation?.result;
    const creditLimit = balance?.result?.InvoiceAccountCreditLimit;
    const accountNumber = result?.AccountNumber;
    const attributes = result?.Attributes;
    //VSI Customization Start - to find if its not a prepaid customer
    let isPrepaidCustomer: boolean = false;
    if (attributes?.length) {
        isPrepaidCustomer = true;
    }
    //VSI customization end
    return (
        <Module {...AccountWelcomeTile}>
            <h2 className='ms-account-welcome-tile__heading'>{myAccount}</h2>
            {_getBalance(accountNumber, creditLimit, context, isPrepaidCustomer)}
        </Module>
    );
};

export default AccountWelcomeTileView;
